import * as React from "react";
import { createBemBlockBuilder } from "@ebsco-ui/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFrown } from "@fortawesome/pro-solid-svg-icons";

import "./error.scss";

export interface ErrorProps {
  children: React.ReactNode;
  className?: string;
  title: string;
  description: string;
}

const Error = ({
  children,
  className: consumerBlockClassName,
  title,
  description,
}: ErrorProps) => {
  const getBemBlocksWith = createBemBlockBuilder([
    "eb-error",
    consumerBlockClassName,
  ]);

  return (
    <div className={getBemBlocksWith()}>
      <div className={getBemBlocksWith("__icon")}>
        <FontAwesomeIcon icon={faFrown} />
      </div>
      <div className={getBemBlocksWith("__message")}>
        <strong className={getBemBlocksWith("__title")}>{title}&nbsp;</strong>
        <h2 className={getBemBlocksWith("__description")}>
          {description}&nbsp;
        </h2>
        <p className={getBemBlocksWith("__body")}>{children}</p>
      </div>
    </div>
  );
};

export default Error;
